import request from "../services/request"
import database from "../services/database"
import bus from "../services/bus"

export default class Base {
  constructor(name) {
    this.name = name
    bus.$on("auth:logout", () => this._reset())
  }

  // Returns a single row matching an identifier.
  find(id) {
    return this.promise()
      .then(table => table.get(id))
  }

  // Returns all rows, or all rows matching a list of identifiers.
  all(ids) {
    return this.promise().then(table => {
      if (ids) {
        return table.where("id").anyOf(ids).toArray()
      }
      return table.toArray()
    })
  }

  // Ensures that the IDB table has been populated.
  promise() {
    if (!this._promise) {
      this._promise = this.reload()
        .catch(reason => window.console && window.console.error(reason))
    }
    return this._promise
  }

  // Forcefully refreshes the list in IDB, by always loading the whole list from
  // the network then filling the IDB table (if possible).
  async reload() {
    const table = database[this.name]
    try {
      const response = await this.fetch()
      if (response) {
        await table.clear()

        if (Array.isArray(response)) {
          await table.bulkPut(response)
        } else {
          await table.bulkPut(response[this.name])
        }
      }
    } catch (ex) {
      console.debug(`failed to load ${this.name}:`, ex)
    }
    return table
  }

  async fetch() {
    const response = await request.get(`/api/v4/${this.name}`)
    const collection = Array.isArray(response) ? response : response[this.name]
    collection.forEach(obj => this._fixModel(obj))
    return response
  }

  _reset() {
    this._promise = null
  }

  _fixModel(obj) {
    return obj
  }
}
